import { css } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { useTranslation } from '@eti/providers';

const styles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  text-align: center;
`;

const AddOnNotAvailable = () => {
  const { t } = useTranslation();
  return (
    <DangerousHtmlContent
      className={styles}
      content={t('Postbooking.ProductPage.AddOnNotAvailable')}
    />
  );
};

export default AddOnNotAvailable;
